export default __webpack_public_path__ + "static/media/FinishedStage_SFX.1a1e3d8f.mp3";